import echarts from '@/config/echarts/index.js'
import moment from 'moment'

export function getRainLiveOption () {
  return {
    color: ['#49B2FF', '#5DF5EC'],
    legend: {
      show: true,
      top: 0,
      itemWidth: 14,
      itemHeight: 9,
      itemGap: 20,
      icon: 'circle',
      textStyle: {
        color: '#FFF',
        fontSize: '0.8rem'
      }
    },
    grid: {
      // left: 40,
      // right: 40,
      top: 30,
      bottom: 20
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontStyle: '0.63vw' // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
      },
      formatter: function (params) {
        var result = ''
        var dotHtml2 = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#5c7bd9"></span>' // 定义第一个数据前的圆点颜色
        var dotHtml = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#99cc66"></span>' // 定义第二个数据前的圆点颜色
        result += moment(Number(params[0].axisValue)).format('DD日HH时') + '</br>' + dotHtml + ' 降水 ' + params[0].data + 'mm' + '</br>' + dotHtml2 + ' 累计降水 ' + Number(params[1].data).toFixed(2) + 'mm'
        return result
      }
    },
    xAxis: {
      data: [],
      axisLine: {
        onZero: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem',
        formatter: function (value) {
          return moment(Number(value)).format('HH')
        }
      }
    },
    yAxis: [
      {
        type: 'value',
        name: '降水（mm）',
        nameLocation: 'end',
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem'
          // align: 'right'
        },
        splitLine: {
          show: false
        },
        splitNumber: 4,
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      },
      {
        type: 'value',
        name: '累计（mm）',
        nameLocation: 'end',
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem'
          // align: 'left'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      }
    ],
    series: [
      {
        name: '降水（mm）',
        type: 'bar',
        barWidth: '7rem',
        width: '15px',
        yAxisIndex: 0,
        data: [],
        label: {
          show: false,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 1,
            color: 'rgba(88, 223, 217, 1)'
          },
          {
            offset: 0.5,
            color: 'rgba(88, 223, 217, 0.5)'
          },
          {
            offset: 0,
            color: 'rgba(255, 255, 255, 0)'
          }
        ]),
        itemStyle: {
          normal: {
            barBorderRadius: [2, 2, 0, 0]
          }
        }
      },
      {
        name: '累计降水（mm）',
        type: 'line',
        yAxisIndex: 1,
        smooth: true,
        data: [],
        label: {
          show: false,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        showSymbol: false,
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0// 0.1的线条是非常细的了
            }
          }
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(88, 143, 249, 0.85)'
            },
            {
              offset: 1,
              color: 'rgba(2, 86, 247, 0.1)'
            }
          ])
        }
      }
    ]
  }
}
